const DEFAULT_FEATURES = [
  "Air conditioning",
  "Bluetooth audio",
  "Reverse camera",
  "USB charging",
  "Comprehensive insurance",
  "Unlimited mileage",
  "24/7 roadside support",
];

export default function FeaturesList({ features }: { features: string[] | null }) {
  const list = features && features.length ? features : DEFAULT_FEATURES;

  return (
    <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2">
      {list.map((feature) => (
        <li key={feature} className="flex items-center gap-2.5 rounded-lg border border-background-200/60 bg-background-100 px-3.5 py-3 text-sm text-foreground-800">
          <span className="flex h-6 w-6 items-center justify-center rounded-full bg-accent-500/15 text-sm text-accent-400">
            <i className="ri-check-line"></i>
          </span>
          {feature}
        </li>
      ))}
    </ul>
  );
}